module.exports = __webpack_public_path__ + "img/ic-travaux.90be933d.svg";